import Price from '~/utils/Price/Price';

export class ProductComputedPrice {
	constructor(
		public readonly type: string,
		public readonly sourceCurrencyPrice: Price,
		public readonly description: string,
		public readonly selected: boolean,
		public readonly targetCurrencyPrice: Price,
		public readonly exchangeRate: {
			value: string;
			factor: string;
		}
	) {}
}
